import { apiSlice } from "app/api/apiSlice";


export const whistleApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['Whistle', 'MyWhistle'],
    endpoints: builder => ({

        // GET All Whistles
        getAllWhistles: builder.query({
            query: (pageNumber) => {
                return {
                    url: 'whistle',
                    params: {
                        page: pageNumber
                    }
                }
            },
            providesTags: ['Whistle']
        }),

        getMyWhistles: builder.query({
            query: (pageNumber) => {
                return {
                    url: 'whistle/me',
                    params: {
                        page: pageNumber
                    }
                }
            },
            providesTags: ['MyWhistle']
        }),

        // GET Anonymous Whistle
        getAnonymousWhistle: builder.query({
            query: (keyCode) => {
                return {
                    url: 'whistle/anonymous',
                    params: {
                        code: keyCode
                    }
                }
            },
            providesTags: ['MyWhistle']
        }),

        // GET Whistles Stats
        getWhistlesStats: builder.query({
            query: () => 'whistle/stats',
            providesTags: ['Whistle']
        }),

        // EDIT Whistle
        updateWhistle: builder.mutation({
            query: whistleUpdate => ({
                url: 'whistle',
                method: 'PUT',
                body: whistleUpdate
            }),
            invalidatesTags: ['Whistle']
        }),

        // POST a new Whistle
        sendWhistle: builder.mutation({
            query: whistle => ({
                url: 'whistle',
                method: 'POST',
                body: whistle
            }),
            invalidatesTags: ['MyWhistle']
        }),
    })
})

export const {
    useGetAllWhistlesQuery,
    useGetMyWhistlesQuery,
    useLazyGetAnonymousWhistleQuery,
    useGetWhistlesStatsQuery,
    useUpdateWhistleMutation,
    useSendWhistleMutation
} = whistleApiSlice